import { JSX } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Divider } from "antd";
import { useQuery } from "react-query";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import { CardContainer } from "../../components/Card/CardContainer";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import { resolveShopTierConfig } from "../ShopTier/config";
import { useLocalStorage } from "../../hook/useLocalStorage";
import { getTierProgramDetail } from "../../datasource/TierProgramDatasource";
import Step2 from "./CreateShopTierBenefitStep/Step2";

// Read-only twin of EditShopTierBenefit: same Step2 form, nothing editable, no save step.
function ViewShopTierBenefit(): JSX.Element {
  const navigate = useNavigate();
  // The route param is named `year`, but ShopTierBenefit navigates here with the tierProgramId.
  const { year: tierProgramId } = useParams<{ year: string }>();
  const [company] = useLocalStorage("profile", null);
  const config = resolveShopTierConfig(company?.company);

  // Same key and fetcher as Step2, so both read one cached request.
  const { data: tierProgramDetail } = useQuery(
    ["tier-program-detail", tierProgramId],
    () => getTierProgramDetail(tierProgramId as string),
    { enabled: !!tierProgramId, refetchOnWindowFocus: false },
  );
  const programYear: number = tierProgramDetail?.responseData?.year ?? 0;
  const titleYear = programYear ? ` ปี ${programYear}` : "";

  return (
    <CardContainer>
      <PageTitleNested
        title={`รายละเอียดสิทธิประโยชน์${titleYear}`}
        showBack
        onBack={() => navigate(-1)}
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "ตั้งค่าระดับ", path: -1 },
              { text: `รายละเอียดสิทธิประโยชน์${titleYear}`, path: window.location.pathname },
            ]}
          />
        }
      />
      <Divider />
      <Step2
        mode="edit"
        readOnly
        config={config}
        sourceTiers={[]}
        tierProgramId={tierProgramId}
        company={company?.company}
        onBack={() => navigate(-1)}
        onNext={() => undefined}
      />
    </CardContainer>
  );
}

export default ViewShopTierBenefit;
